import { Injectable } from '@angular/core';
import { TelephonyContext } from 'src/app/models/telephonyv2';

@Injectable({
    providedIn: 'root'
})
export class MemberSessionService {

    constructor() { }

    static getContextByMemberGroupHash(contexts: TelephonyContext[], hash: string) {
        const index = contexts?.findIndex(contextItem => contextItem.memberGroupHash === hash);
        const context = index >= -1 ? contexts[index] : null;
        return { context, contextIndex: index };
    }

    static getContextByMemberId(contexts: TelephonyContext[], memberId: string) {
        const index = contexts.findIndex(contextItem => contextItem.triggerMemberId === memberId || contextItem?.memberGroupHashSource.some(memberGroupItem => memberGroupItem.id === memberId));
        const context = index >= -1 ? contexts[index] : null;
        return { context, contextIndex: index };
    }
}
